import { createWorkLog, listWorkLogs } from "../../../services/workLog";
import { WSServiceError } from "../../../utils/serviceHelper";
import { useWSMutation } from "../../helpers";
import { QUERY_WORK_LOGS } from "../queries/useQueryWorkLogs";
import { QUERY_WORK_LOGS_SUMMARY } from "../queries/useQueryWorkLogsSummary";

export const useMutationGetOrCreateWorkLog = () =>
  useWSMutation<
    Awaited<ReturnType<typeof createWorkLog>>,
    WSServiceError,
    {
      payerPayeeEngagementId: string;
    }
  >(
    async ({ payerPayeeEngagementId }) => {
      const workLogs = await listWorkLogs({
        "filter[payerPayeeEngagementId][=]": payerPayeeEngagementId,
        "filter[endDate][exists]": false
      });

      const workLog = workLogs[0];

      if (workLog) {
        return workLog;
      }

      return await createWorkLog({
        startDate: new Date(),
        payerPayeeEngagementId
      });
    },
    {
      dependencies: [QUERY_WORK_LOGS, QUERY_WORK_LOGS_SUMMARY]
    }
  );
